/**
 * Contacts role actions.
 *
 * ⚠️ These gate NAVIGATION ONLY — they are not a security boundary.
 * The api.core `CustomContact` controller carries no `[Authorize(Roles = …)]` attribute at all, so
 * every authenticated role (Party Agent, Observer, everyone) can call the endpoints directly, and
 * each gets their own private contact book. `CONTACTS_SHARE` in particular protects nothing
 * server-side. Real enforcement needs role attributes on the controller.
 *
 * ⚠️ A menu item only appears once the action exists in the BACKEND catalogue, is granted to the
 * role, and the user re-logs (same as `actions.result_audit.ts` / `result_time_machine`). Until the
 * catalogue is synced via the Sync Permission Catalogue tool, the nav entry is gated on
 * VOTER_INTERACTION so the module is reachable.
 */
export const ACTIONS_CONTACTS = {
	CONTACTS: 'contacts',
	CONTACTS_VIEW: 'contacts_view',
	CONTACTS_MANAGE: 'contacts_manage',
	CONTACTS_SHARE: 'contacts_share',
} as const;
